import { CargoHashIdGenerator } from './CargoHashIdGenerator.js'

export * from './CargoHashId.js'
export * from './CargoHashIdGenerator.js'

const HashId = new CargoHashIdGenerator()
export default HashId
export { HashId }
